import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { COLORS } from '../../constants/constants';
import { ReactComponent as ChipExitIcon } from '../../images/chip-exit.svg';

interface FilterChipProps {
    text: string;
    onClose: any;
}

const FilterChip: React.FC<FilterChipProps> = ({ text, onClose }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid',
                borderRadius: '40px',
                pl: 1,
                pr: 1,
                mr: 1,
                mb: 1,
            }}
            className="border-color-b background-color-blst background-color-hover color-b"
        >
            <Typography sx={{ fontWeight: '500' }} className="color-b">
                {text}
            </Typography>
            <IconButton
                onClick={onClose}
                sx={{
                    'p': 0,
                    'ml': 1,
                    'fill': COLORS.BRAND,
                    '&:hover': {
                        fill: `${COLORS.BRAND_HOVER}`,
                    },
                    '&:active': {
                        fill: `${COLORS.BRAND_ACTIVE} !important`,
                    },
                }}
            >
                <ChipExitIcon />
            </IconButton>
        </Box>
    );
};

export default FilterChip;
